import { useState } from 'react'
import { api } from '../lib/api'

export default function Settings({ business, onUpdate }) {
  const [form, setForm] = useState({
    name: business.name,
    owner_phone: business.owner_phone,
    google_review_link: business.google_review_link,
  })
  const [loading, setLoading] = useState(false)
  const [saved, setSaved] = useState(false)
  const [error, setError] = useState('')

  function handleChange(e) {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }))
  }

  async function handleSubmit(e) {
    e.preventDefault()
    setLoading(true)
    setError('')
    try {
      // Normalize phone number
      let phone = form.owner_phone.replace(/\D/g, '')
      if (phone.length === 10) phone = '+1' + phone
      else if (phone.length === 11 && phone.startsWith('1')) phone = '+' + phone
      else if (!phone.startsWith('+')) phone = '+1' + phone

      const updated = await api.updateBusiness(business.id, { ...form, owner_phone: phone })
      onUpdate(updated)
      setSaved(true)
      setTimeout(() => setSaved(false), 3000)
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div>
      <h1 style={styles.pageTitle}>Settings</h1>
      <p style={styles.pageSub}>Update your business info and notification preferences.</p>

      <div style={styles.card}>
        <form onSubmit={handleSubmit} style={styles.form}>
          <label style={styles.label}>Business Name</label>
          <input style={styles.input} name="name" value={form.name} onChange={handleChange} required />

          <label style={styles.label}>Your Mobile Number</label>
          <input
            style={styles.input}
            name="owner_phone"
            placeholder="3215550000"
            value={form.owner_phone}
            onChange={handleChange}
            required
          />
          <p style={styles.hint}>Enter just your 10-digit number — we'll format it automatically.</p>

          <label style={styles.label}>Google Review Link</label>
          <input style={styles.input} name="google_review_link" value={form.google_review_link} onChange={handleChange} required />

          {error && <p style={styles.error}>{error}</p>}
          {saved && <p style={styles.success}>✓ Settings saved</p>}

          <button style={styles.button} type="submit" disabled={loading}>
            {loading ? 'Saving...' : 'Save Changes'}
          </button>
        </form>
      </div>
    </div>
  )
}

const styles = {
  pageTitle: { fontSize: 28, fontWeight: 700, margin: '0 0 8px', color: '#fff' },
  pageSub: { color: '#6b6b80', fontSize: 14, margin: '0 0 32px' },
  card: {
    background: '#13131a',
    border: '1px solid #1e1e2e',
    borderRadius: 16,
    padding: '32px',
    maxWidth: 480,
  },
  form: { display: 'flex', flexDirection: 'column', gap: 8, fontFamily: "'DM Sans', sans-serif" },
  label: { color: '#a0a0b8', fontSize: 13, fontWeight: 600, marginTop: 8 },
  input: {
    background: '#1a1a24',
    border: '1px solid #2a2a3a',
    borderRadius: 8,
    padding: '12px 16px',
    color: '#fff',
    fontSize: 14,
    outline: 'none',
  },
  hint: { color: '#4a4a60', fontSize: 12, margin: '2px 0 0' },
  error: { color: '#ff4d4d', fontSize: 13 },
  success: { color: '#22c55e', fontSize: 13 },
  button: {
    background: '#4f46e5',
    color: '#fff',
    border: 'none',
    borderRadius: 8,
    padding: '13px 0',
    fontSize: 15,
    fontWeight: 600,
    cursor: 'pointer',
    marginTop: 16,
  },
}
